import { createRouter, createWebHistory } from 'vue-router'

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/login', name: 'login', component: () => import('./pages/LoginPage.vue'), meta: { public: true } },
    { path: '/', redirect: '/payments' },
    { path: '/payments', name: 'payments', component: () => import('./pages/PaymentsPage.vue'), meta: { title: 'Payments' } },
    { path: '/payments/:id', name: 'payment', component: () => import('./pages/PaymentPage.vue'), meta: { title: 'Payment' } },
    { path: '/design', name: 'design', component: () => import('./pages/DesignPage.vue'), meta: { title: 'Design' } },
    { path: '/checkout', name: 'checkout', component: () => import('./pages/CheckoutPage.vue'), meta: { title: 'Checkout settings' } },
    { path: '/developers', name: 'developers', component: () => import('./pages/DevelopersPage.vue'), meta: { title: 'Developers' } },
    { path: '/developers/docs', name: 'docs', component: () => import('./pages/DocsPage.vue'), meta: { title: 'API reference' } },
    { path: '/domains', name: 'domains', component: () => import('./pages/DomainsPage.vue'), meta: { title: 'Domains' } },
    { path: '/:rest(.*)*', redirect: '/payments' },
  ],
})

router.afterEach((to) => {
  document.title = to.meta.title ? `${String(to.meta.title)} · FlowFront Console` : 'FlowFront Console'
})
